<script setup lang="ts">
const { params } = useShop();
const options = [
  { value: "timestamp:desc", text: "Nouveautés" },
  { value: "name:asc", text: "Alphabétique, A-Z" },
  { value: "name:desc", text: "Alphabétique, Z-A" },
  { value: "price:desc", text: "Prix décroissant" },
  { value: "price:asc", text: "Prix croissant" },
];
</script>

<template>
  <UiDropdown v-model="params.sort_by" label="Trier par:" :options="options" />
</template>
